export default {
  functionKey: "SIERREUR",
  title: "SIERREUR",
  group: "Organisation",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "Default", name: "Valeur par défaut", empty: true }],
  expectedArguments: [
    { name: "Valeur par défaut", argumentKey: "Default", single: true, initialValue: "", empty: true }
  ],
  description: "Retourne la valeur d'origine, ou la valeur par défaut si elle est vide/nulle.",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const fallback = args[0] ?? "''";
    const code = `${destination} = (${origin} !== null && ${origin} !== undefined && ${origin} !== '') ? ${origin} : ${fallback};`;
    return { displayCode: code, safeCode: code };
  }
}
